import React, { createContext, useState } from 'react';

export const OnlyUnreadStateContext = createContext();
export const OnlyUnreadDispatchContext = createContext();

export const OnlyUnreadProvider = ({ children }) => {
  const [onlyUnread, setOnlyUnread] = useState(false);

  return (
    <OnlyUnreadStateContext.Provider value={onlyUnread}>
      <OnlyUnreadDispatchContext.Provider value={setOnlyUnread}>
        {children}
      </OnlyUnreadDispatchContext.Provider>
    </OnlyUnreadStateContext.Provider>
  );
};
